import { gql } from "@apollo/client";
import { AIMessageFragments } from "AppComponents/GPTPlayground/modules/GPTPlaygroundFragments";
import { attachmentFragment } from "modules/CommonFragments";

export const getAiConversationsQuery = gql`
  query getAiConverstions($filters: AiConversationFilters) {
    ai {
      aiConversations(filters: $filters) {
        edges {
          node {
            id
            entityType
            metadata
          }
        }
      }
    }
  }
`;

export const getAiConversationDetailsQuery = gql`
  query getAiConversationDetails($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        entityType
        metadata
        messages {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...aiMessageItem
            }
          }
        }
        attachments {
          ...attachmentItem
        }
        publicUrl
      }
    }
  }
  ${attachmentFragment.attachment}
  ${AIMessageFragments.AIMessage}
`;

export const getAiToolDetailsQuery = gql`
  query getAiToolDetails($filters: AiToolDetailFiltersInput) {
    ai {
      aiToolDetails(filters: $filters) {
        id
        name
        description
        schema
        toolHandler
        version
        displaySequence
        createdBy
        createdAt
        updatedAt
      }
    }
  }
`;

export const getCmsAiToolsQuery = gql`
  query getCmsAiTools {
    cms {
      aiTools {
        id
        name
        description
        version
        schema
        toolHandler
        status
      }
    }
  }
`;

export const getAiUsageMetricsForImportQuery = gql`
  query getAiUsageMetricsForImport($id: ID!) {
    node(id: $id, type: AI_USAGE_METRICS) {
      id
      ... on AiUsageMetrics {
        id
        type
        inputText
        responseText
        promptTokens
        completionTokens
        cachedPromptTokens
        model
        temperature
        metadata
        isError
        errorMessage
        createdAt
        createdBy
      }
    }
  }
`;
